import { Box, BoxProps } from "@chakra-ui/react";

export interface StatBarWrapperProps extends BoxProps {}

export const StatBarWrapper = (props: StatBarWrapperProps) => {
  return (
    <Box
      display={{ base: "none", md: "flex" }}
      color="white"
      bg="lightBlue.600"
      fontSize="sm"
      minH="30px"
      {...props}
    />
  );
};
